/** Cấu hình public — ưu tiên runtime `app-config.json`, fallback biến build Vite. */

export type PublicEnvConfig = {
  baseApi: string;
  imageApi: string;
  docApi: string;
  facilityId: string;
  acceptType: string;
};

function readEnv(key: string, fallback = ""): string {
  const viteKey = key.replace(/^NEXT_PUBLIC_/, "VITE_");
  const fromMeta = import.meta.env[key] ?? import.meta.env[viteKey];
  return typeof fromMeta === "string" ? fromMeta : fallback;
}

function readBuildDefaults(): PublicEnvConfig {
  return {
    baseApi: readEnv("NEXT_PUBLIC_BASE_API") || readEnv("VITE_BASE_API"),
    imageApi: readEnv("NEXT_PUBLIC_IMAGE_API") || readEnv("VITE_IMAGE_API"),
    docApi: readEnv("NEXT_PUBLIC_DOC_API") || readEnv("VITE_DOC_API"),
    facilityId:
      readEnv("NEXT_PUBLIC_FACILITY_ID") ||
      readEnv("VITE_FACILITY_ID") ||
      "00000000-0000-8000-0000-000000000000",
    acceptType:
      readEnv("NEXT_PUBLIC_ACCEPT_TYPE").trim() ||
      readEnv("VITE_ACCEPT_TYPE").trim() ||
      "application/x-vnpt",
  };
}

/** Mutable — được ghi đè bởi app-config.json lúc khởi động. */
export const publicEnv: PublicEnvConfig = readBuildDefaults();

function applyPartialConfig(raw: Partial<PublicEnvConfig>) {
  if (typeof raw.baseApi === "string" && raw.baseApi.trim())
    publicEnv.baseApi = raw.baseApi.trim().replace(/\/+$/, "");
  if (typeof raw.imageApi === "string" && raw.imageApi.trim())
    publicEnv.imageApi = raw.imageApi.trim().replace(/\/+$/, "");
  if (typeof raw.docApi === "string" && raw.docApi.trim())
    publicEnv.docApi = raw.docApi.trim().replace(/\/+$/, "");
  if (typeof raw.facilityId === "string" && raw.facilityId.trim())
    publicEnv.facilityId = raw.facilityId.trim();
  if (typeof raw.acceptType === "string" && raw.acceptType.trim())
    publicEnv.acceptType = raw.acceptType.trim();
}

/**
 * Tải /app-config.json từ thư mục dist (IIS).
 * Chỉnh file này trên server → đổi API URL không cần npm run build lại.
 */
export async function initPublicEnv(): Promise<void> {
  try {
    const res = await fetch(`/app-config.json?ts=${Date.now()}`, {
      cache: "no-store",
    });
    if (res.ok) {
      const cfg = (await res.json()) as Partial<PublicEnvConfig>;
      applyPartialConfig(cfg);
    }
  } catch {
    /* Giữ giá trị từ .env.production lúc build */
  }

  const { applyApiClientConfig } = await import("@/lib/api/client");
  applyApiClientConfig(publicEnv);
}
